/* eslint-disable max-lines */
import { get_token, get_user_details } from "@/router";
import NotificationDropdown from '@/components/Notifications/Notification.vue'
import MenuSideBar from '@/components/MenuSidebar/MenuSidebar.vue'
import CreatePortal from "@/components/CreatePortal/CreatePortal.vue";
import Loader from "@/components/Loader/LoaderView";
import Swal from 'sweetalert2';
import { client_domain } from "@/main.js";
import { append_active_organization_id } from "@/utils/organization_profile";
import { HOME_FEATURE_ICONS } from "@/utils/home_feature_icons";


export default {
  props: {
    activeTab: String,
    portal_admin: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select-voice-tab'],
  components: {
    NotificationDropdown,
    MenuSideBar,
    CreatePortal,
    Loader
  },

  computed: {
    isHomePage() {
      return this.$route.name === 'home'; // Assuming your home page route is named 'home'
    },
    isHomeFilterPage() {
      return this.$route.name === 'organisation';
    },
    isAdverts() {
      return this.$route.name === 'adverts';
    },
    isPersonalProfile() {
      return this.$route.name === 'view_personal_profiles';
    },
    isPortalPage() {
      return this.$route.name === 'view_portal';
    },
    is_group_page() {
      return this.$route.name === 'view_group';
    },
    is_business_page() {
      return this.$route.name === 'view_business_profiles';
    },
    is_publish_portal() {
      return this.$route.name === 'publish_portal';
    },
    is_publish_report() {
      return this.$route.name === 'view_full_report';
    },
    // 1. Portals user is approved for
    your_portals() {
      return this.portals.filter(p =>
        p.name?.toLowerCase() !== 'default portal' &&
        !this.portal_is_public(p) &&
        p.has_access === 'approved'
      );
    },

    // 2. All discoverable portals not already in "your portals"
    other_portals() {
      return this.portals.filter(p => {
        const isDefault = p.name?.toLowerCase() === 'default portal';
        if (isDefault) return false;

        return this.portal_is_public(p) || (this.portal_is_discoverable(p) && p.has_access !== 'approved');
      });
    },
    displayed_your_portals() {
      return this.show_all_your_portals
        ? this.your_portals
        : this.your_portals.slice(0, this.your_portals_visible_count);
    },
    has_more_your_portals() {
      return this.your_portals.length > this.your_portals_visible_count;
    },
    active_mobile_nav_key() {
      const route_map = {
        home: 'feeds',
        Feed: 'feeds',
        organisation: 'feeds',
        view_portal: 'portals',
        Marketplace: 'marketplace',
        marketplace: 'marketplace',
        incident_reporting: 'incident',
        view_events: 'events',
        view_group: 'groups',
        my_shop: 'menu',
        my_services: 'menu',
        my_orders: 'menu',
        dashboard: 'menu',
        view_business_profiles: 'business_profiles',
        business_profile_direct: 'business_profiles',
        view_personal_profiles: 'personal_profiles',
        personal_profile_direct: 'personal_profiles',
        personal_profile_list: 'personal_profiles',
      };

      return Reflect.get(route_map, this.$route.name) || '';
    },
    mobile_nav_keys() {
      if (this.is_your_voice_mobile_nav) {
        return ['feeds', 'discussions', 'surveys', 'polls', 'menu'];
      }
      return this.get_displayed_mobile_nav_keys();
    },
    is_your_voice_mobile_nav() {
      return this.activeTab === 'top_loans_info' || this.activeTab === 'voice';
    },
    show_group_member_mobile_nav() {
      return this.is_group_page;
    },
    home_feature_icons() {
      return HOME_FEATURE_ICONS;
    }
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.fetchPortals();

    if (client_domain.includes('tdm')) {
      this.tdm_domain = true;
    }
    if (client_domain.includes('workbook')) {
      this.workbook_domain = true;
    }
    if (client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }
    if (client_domain.includes('dwypd') || client_domain.includes('nsp')) {
      this.soulcity = true;
    }
    if(client_domain.includes('chiefluthuli')) {
      this.school_domain = true;
    }
    if (client_domain.includes('demo') || client_domain.includes('engagenet')) {
      this.visible_domain = true;
    }
    if (client_domain.includes('engagenet') || client_domain.includes('apex') ) {
        this.incident = true;
      }
      if (client_domain.includes('engagenet') || client_domain.includes('vettedsa')){
        this.marketplace = true;
      }
  },
 inject: ['client_features'],

  data() {
    return ({
      token_exists: false,
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
      },
      workbook_domain: false,
      school_domain: false,
      visible_domain: false,
      active_voice_mobile_tab: 'discussions',
      portals: [],
      loading: true,
      selectedPortal: null,
      cbo_domain: false,
      soulcity: false,
      tdm_domain: false,
      request_access:false,
      incident:false,
      marketplace:false,
      show_all_your_portals: false,
      your_portals_visible_count: 5
    });
  },
  methods: {
    select_voice_mobile_tab(tab_key) {
      this.active_voice_mobile_tab = tab_key;
      this.$emit('select-voice-tab', tab_key);
    },
    createPortal() {
      this.fetchPortals();
    },
    getToken() {
      return get_token();
    },
    getInitials(name) {
        const words = name.trim().split(" ");
        return words.length === 1
          ? words[0].substring(0, 2).toUpperCase()
          : (words[0][0] + words[1][0]).toUpperCase();
      },
    is_admin_user() {
      return this.user_details.user_role === 'admin'
        || this.user_details.user_role === 'organization admin'
        || this.portal_admin;
    },
    get_visible_mobile_nav_items() {
      return this.get_mobile_nav_items().filter(({ is_visible }) => is_visible());
    },
    get_displayed_mobile_nav_keys() {
      const active_key = this.active_mobile_nav_key;
      const keys = this.get_visible_mobile_nav_items().map(({ key }) => key);
      const fill_order = ['feeds', 'collect', active_key, 'alerts', 'menu', 'portals', 'marketplace', 'events', 'incident', 'groups', 'business_profiles', 'personal_profiles', 'boards', 'group_member'];
      const ordered_keys = fill_order
        .filter(Boolean)
        .filter((key, index, list) => list.indexOf(key) === index)
        .filter((key) => keys.includes(key) || this.can_force_mobile_nav_item(key));

      return this.get_five_mobile_nav_keys(ordered_keys, active_key);
    },
    get_five_mobile_nav_keys(keys, active_key) {
      const priority = ['feeds', 'collect', active_key, 'alerts', 'menu', 'portals', 'marketplace', 'events', 'incident', 'groups', 'business_profiles', 'personal_profiles', 'boards', 'group_member']
        .filter(Boolean);
      const unique_keys = priority
        .filter((key, index, list) => list.indexOf(key) === index)
        .filter((key) => keys.includes(key));

      if (!active_key || !unique_keys.includes(active_key)) {
        return unique_keys.slice(0, 5);
      }

      const trailing_keys = [
        unique_keys.includes('alerts') ? 'alerts' : null,
        unique_keys.includes('menu') ? 'menu' : null,
      ].filter(Boolean);
      const body_slot_count = 5 - trailing_keys.length;
      const body_keys = unique_keys.filter((key) => !trailing_keys.includes(key));

      if (!body_keys.includes(active_key)) {
        return [...body_keys.slice(0, body_slot_count), ...trailing_keys].slice(0, 5);
      }

      const side_keys = body_keys.filter((key) => key !== active_key);
      const left_keys = side_keys.slice(0, 2);
      const right_keys = side_keys.slice(2, 2 + Math.max(body_slot_count - left_keys.length - 1, 0));

      return [...left_keys, active_key, ...right_keys, ...trailing_keys].slice(0, 5);
    },
    is_mobile_nav_item_visible(key) {
      return this.mobile_nav_keys.includes(key);
    },
    can_force_mobile_nav_item(key) {
      if (key === this.active_mobile_nav_key) return this.can_show_active_mobile_nav_item(key);
      if (key === 'portals') return this.can_show_portals_mobile_nav();
      if (key === 'marketplace') return this.can_show_marketplace_mobile_nav();
      if (key === 'events') return this.can_show_events_mobile_nav();
      if (key === 'business_profiles') return this.can_show_business_profiles_mobile_nav();
      if (key === 'personal_profiles') return this.can_show_personal_profiles_mobile_nav();
      return false;
    },
    get_mobile_nav_items() {
      return [
        { key: 'portals', is_visible: this.show_portals_mobile_nav },
        { key: 'boards', is_visible: this.show_boards_mobile_nav },
        { key: 'feeds', is_visible: this.show_feeds_mobile_nav },
        { key: 'collect', is_visible: this.show_collect_mobile_nav },
        { key: 'voice', is_visible: this.show_voice_mobile_nav },
        { key: 'segments', is_visible: this.show_segments_mobile_nav },
        { key: 'marketplace', is_visible: this.show_marketplace_mobile_nav },
        { key: 'incident', is_visible: this.show_incident_mobile_nav },
        { key: 'events', is_visible: this.show_events_mobile_nav },
        { key: 'groups', is_visible: this.show_groups_mobile_nav },
        { key: 'business_profiles', is_visible: this.show_business_profiles_mobile_nav },
        { key: 'personal_profiles', is_visible: this.show_personal_profiles_mobile_nav },
        { key: 'alerts', is_visible: this.show_alerts_mobile_nav },
        { key: 'group_member', is_visible: this.show_group_member_mobile_nav_item },
        { key: 'menu', is_visible: this.show_menu_mobile_nav },
      ];
    },
    all_mobile_nav_conditions(conditions) {
      return conditions.every(Boolean);
    },
    show_portals_mobile_nav() {
      return false;
    },
    can_show_portals_mobile_nav() {
      return this.all_mobile_nav_conditions([this.client_features.show_portals, !this.is_group_page, this.token_exists]);
    },
    show_boards_mobile_nav() {
      return this.all_mobile_nav_conditions([!this.isHomePage, !this.is_group_page, !this.isHomeFilterPage, this.isPortalPage, this.token_exists]);
    },
    show_feeds_mobile_nav() {
      return true;
    },
    show_voice_mobile_nav() {
      return this.$route.name === 'Feed'
        && !this.is_your_voice_mobile_nav
        && this.activeTab === 'normal_loans_info'
        && this.client_features.show_your_voice;
    },
    show_collect_mobile_nav() {
      return !this.is_your_voice_mobile_nav;
    },
    show_segments_mobile_nav() {
      return this.show_boards_mobile_nav();
    },
    show_marketplace_mobile_nav() {
      return false;
    },
    can_show_marketplace_mobile_nav() {
      return this.all_mobile_nav_conditions([this.client_features.show_marketplace, !this.isPortalPage, !this.is_business_page, !this.is_group_page]);
    },
    show_incident_mobile_nav() {
      return this.all_mobile_nav_conditions([this.client_features.show_incident, !this.isPortalPage, !this.is_business_page, !this.is_group_page]);
    },
    show_events_mobile_nav() {
      return false;
    },
    can_show_events_mobile_nav() {
      return this.all_mobile_nav_conditions([this.client_features.show_events, !this.is_group_page, !this.isHomeFilterPage, !this.isPortalPage]);
    },
    show_business_profiles_mobile_nav() {
      return false;
    },
    can_show_business_profiles_mobile_nav() {
      return this.all_mobile_nav_conditions([this.client_features.show_business_profile, !this.tdm_domain, !this.is_group_page]);
    },
    show_personal_profiles_mobile_nav() {
      return false;
    },
    can_show_personal_profiles_mobile_nav() {
      return this.all_mobile_nav_conditions([this.client_features.show_personal_profile, !this.is_group_page]);
    },
    show_groups_mobile_nav() {
      return this.is_group_page || this.all_mobile_nav_conditions([!this.isHomePage, this.token_exists, this.isPortalPage]);
    },
    show_alerts_mobile_nav() {
      return this.token_exists;
    },
    show_group_member_mobile_nav_item() {
      return this.show_group_member_mobile_nav;
    },
    show_menu_mobile_nav() {
      return true;
    },
    show_groups_menu_item() {
      return this.token_exists && (this.$route.name === 'Feed' || this.isPortalPage || this.is_group_page);
    },
    can_show_active_mobile_nav_item(key) {
      const active_item_checks = {
        portals: this.can_show_portals_mobile_nav,
        marketplace: this.can_show_marketplace_mobile_nav,
        events: this.can_show_events_mobile_nav,
        incident: this.show_incident_mobile_nav,
        groups: this.show_groups_mobile_nav,
        business_profiles: this.can_show_business_profiles_mobile_nav,
        personal_profiles: this.can_show_personal_profiles_mobile_nav,
        boards: this.show_boards_mobile_nav,
        alerts: this.show_alerts_mobile_nav,
        menu: this.show_menu_mobile_nav,
        feeds: this.show_feeds_mobile_nav,
        collect: this.show_collect_mobile_nav,
      };
      return Reflect.get(active_item_checks, key)?.() || false;
    },
    is_mobile_nav_active(key) {
      if (this.is_your_voice_mobile_nav) {
        return this.active_voice_mobile_tab === key;
      }
      return this.active_mobile_nav_key === key;
    },
    get_mobile_nav_item_style(key) {
      return ({ order: this.get_mobile_nav_item_order(key) });
    },
    open_collect_mobile_nav() {
      if (this.isPortalPage) {
        this.select_voice_mobile_tab('discussions');
        return;
      }

      if (this.$route.name === 'Feed') {
        this.select_voice_mobile_tab('discussions');
        return;
      }

      sessionStorage.setItem('home_active_tab', 'top_loans_info');
      sessionStorage.setItem('home_voice_active_tab', 'discussions');
      this.$router.push({ name: 'Feed' });
    },
    get_mobile_nav_item_order(key) {
      if (this.is_your_voice_mobile_nav) {
        return this.get_your_voice_mobile_nav_order(key);
      }
      if (key === 'alerts') {
        return 998;
      }
      if (key === 'menu' && this.active_mobile_nav_key !== 'menu') {
        return 999;
      }
      const nav_keys = this.mobile_nav_keys;
      const active_index = nav_keys.indexOf(this.active_mobile_nav_key);
      const item_index = nav_keys.indexOf(key);

      if (item_index < 0 || active_index < 0) {
        return item_index;
      }

      return this.get_centered_mobile_nav_order(item_index, active_index);
    },
    get_your_voice_mobile_nav_order(key) {
      if (key === 'feeds') return 0;
      if (key === 'menu') return 999;
      if (key === this.active_voice_mobile_tab) return 2;

      const side_orders = {};
      this.get_inactive_voice_mobile_nav_keys().forEach((nav_key, index) => {
        Reflect.set(side_orders, nav_key, index === 0 ? 1 : 3);
      });
      return Reflect.get(side_orders, key) || 4;
    },
    get_inactive_voice_mobile_nav_keys() {
      return ['discussions', 'surveys', 'polls']
        .filter(nav_key => nav_key !== this.active_voice_mobile_tab);
    },
    get_centered_mobile_nav_order(item_index, active_index) {
      const center_index = Math.floor((this.mobile_nav_keys.length - 1) / 2);

      if (item_index === active_index) {
        return center_index;
      }

      const adjusted_index = item_index < active_index ? item_index : item_index - 1;
      return adjusted_index >= center_index ? adjusted_index + 1 : adjusted_index;
    },
    portal_is_public(portal) {
      return String(portal?.is_public).toLowerCase() === 'true';
    },
    portal_visibility_enabled(portal) {
      return String(portal?.is_visible).toLowerCase() === 'true';
    },
    portal_user_has_access(portal) {
      return portal?.has_access === 'approved';
    },
    portal_is_discoverable(portal) {
      if (this.portal_is_public(portal)) {
        return true;
      }

      if (this.is_admin_user()) {
        return true;
      }

      if (this.portal_user_has_access(portal)) {
        return true;
      }

      return this.portal_visibility_enabled(portal);
    },
    portal_can_request_access(portal) {
      return (
        !this.portal_is_public(portal) &&
        this.portal_visibility_enabled(portal) &&
        portal?.has_access !== 'approved' &&
        portal?.has_access !== 'pending'
      );
    },
    toggle_your_portals() {
      this.show_all_your_portals = !this.show_all_your_portals;
    },
    fetchPortals() {
      this.token_exists = this.getToken();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
        method: 'POST',
        headers: this.token_exists
          ? {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          }
          : {},
        data: JSON.stringify(append_active_organization_id(this.payload)),
        success: (data) => {
          if (data.portals) {
            this.portals = data.portals.filter(
                  portal => portal.name?.toLowerCase() !== 'default portal'
                );
          } else {
            this.portals = [];
          }

          setTimeout(() => {
            this.loading = false;
          }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    handle_unauthenticated() {
      if (!this.token_exists) {
        this.$router.push({ name: 'login' });
        return false;
      }
      return true;
    },
    open_portal(portal_id, portal_name, is_public, portal_type, is_visible) {

      if (portal_type?.name === 'incident') {
        this.$router.push({ name: 'view_incidents', params: { portal_id: portal_id, portal_name: portal_name, } });
      }
      else if (portal_type?.name === 'publishing') {

        this.$router.push({ name: 'publish_portal', params: { portal_id: portal_id, portal_name: portal_name, } });
      }
      else {

        this.$router.push({ name: 'view_portal', params: { portal_id: portal_id, portal_name: portal_name, is_public: is_public, is_visible: is_visible } });
        this.filterReports(portal_id);
      }
    },
    filterReports(portal_id) {
      this.loading = true;
      const payload = {
        filter_values: {
          portal_id: portal_id
        }
      }
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_reports_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            this.$emit('portal_selected', response.data.report_data);
          }

          setTimeout(() => {
            this.loading = false;
          }, 1000);

        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    handlePortalClick(portal) {
      if (!this.handle_unauthenticated()) {
        return;
      }
      this.is_public = portal.is_public


      if (portal.has_access == "approved") {
        this.$emit('portal_profile', portal);
        this.open_portal(portal.id, portal.name, portal.is_public, portal.portal_type, portal.is_visible);

        // this.get_portal_access_requested_users();
        $("#request_access").modal('hide');
      }

      else if (portal.has_access == "pending") {
        $("#request_access").modal('hide');
        Swal.fire({
          icon: 'info',
          title: 'Info',
          text: 'Access request already submitted.',
          showConfirmButton: false,
          timer: 3000,
          position: 'bottom-end',
          toast: true
        })
        return;
      }

      else {
        $("#request_access").modal('show');
        this.selectedPortal = portal;
        return;
      }

    },

    requestAccess() {
      const PORTAL_ID = this.selectedPortal ? this.selectedPortal.id : null;

      this.request_access = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/request_access_private_portal/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          portal_id: PORTAL_ID,
        }),
        success: (data) => {
          if (data.status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Access request submitted successfully.',
              showConfirmButton: false,
              timer: 3600,
              position: 'bottom-end',
              toast: true
            })
          }
          else {
            Swal.fire({
              icon: 'info',
              title: 'Info',
              text: 'Request Already Sent',
              showConfirmButton: false,
              timer: 3000,
              position: 'bottom-end',
              toast: true
            })
          }
        },
        complete: () => {
          this.isLoading = false;
          this.selectedPortal = null;
          this.request_access = false;
          $("#request_access").modal('hide');
        }
      });
    },
  }
}
